import { Typography, Button } from "../../components"
import "./styles.css";

import gidsvoorprofessionals from '../../assets/documents/library/gidsvoorprofessionals2025.pdf';

export default function GidsvoorProfessionals(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Gids voor Professionals</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={gidsvoorprofessionals} 
                    text={`Klik hier voor onze Gids voor Professionals`}
                />
            </div>
        </div>
    )
}